import { connect } from 'react-redux'
import { toggleDrawer, toggleAppbarWhiteFont, getOrganization, getEnumeration, GetPos, 
    PatchPos, GetPosRoute, GetPosAccounts, UpdatePosRoute, getApiKeys, createApiKeys, deleteApiKeys
} from '../actions'
import CheckoutPage from '../components/CheckoutPage'

const mapStateToProps = state => ({
    openDrawer: state.navDrawers.isOpen,
    appbarIsWhiteFont: state.appBars.appbarIsWhiteFont,
    organization: state.organizations.organization,
    enumeration: (state.misc.enum) || {},
    checkoutpagesread: (state.organizations.role && state.organizations.role.checkoutpagesread) || false,
    checkoutpageswrite: (state.organizations.role && state.organizations.role.checkoutpageswrite) || false,
    organizationPos: state.organizations.organizationPos || [],
    detailedPos: state.organizations.detailedPos || {},
    detailedPosRoutes: state.organizations.detailedPosRoutes || {},
    detailedPosPmtSvcAcc: state.organizations.detailedPosPmtSvcAcc || {},
    detailedPosRoutesRules: state.organizations.detailedPosRoutes || [],
    environment: state.appstate.environment || 'staging',
    posApiKeys: state.apiKeys.posApiKeys || {},
})

const mapDispatchToProps = dispatch => ({
    toggleDrawer: () => dispatch(toggleDrawer()),
    toggleAppbarWhiteFont: (isWhite) => dispatch(toggleAppbarWhiteFont(isWhite)),
    getOrganization: (params) => dispatch(getOrganization(params)),
    getEnumeration: (params) => dispatch(getEnumeration(params)),
    GetPos: (params) => dispatch(GetPos(params)),
    PatchPos: (params, reqBody) => dispatch(PatchPos(params, reqBody)),
    GetPosRoute: (params) => dispatch(GetPosRoute(params)),
    GetPosAccounts: (params) => dispatch(GetPosAccounts(params)),
    UpdatePosRoute: (params, reqBody) => dispatch(UpdatePosRoute(params, reqBody)),
    getApiKeys: (params) => dispatch(getApiKeys(params)),
    createApiKeys: (params, reqBody) => dispatch(createApiKeys(params, reqBody)),
    deleteApiKeys: (params) => dispatch(deleteApiKeys(params)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckoutPage)